/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Input_PlaceholderInputs */

const en_search_input_placeholder = /** @type {(inputs: Search_Input_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Describe what you're building, or search by keyword`)
};

const zh_hans1_search_input_placeholder = /** @type {(inputs: Search_Input_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`描述你正在构建的东西，或按关键词搜索`)
};

const pt_br2_search_input_placeholder = /** @type {(inputs: Search_Input_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descreva o que você está criando ou pesquise por palavra-chave`)
};

const es_search_input_placeholder = /** @type {(inputs: Search_Input_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Describe lo que estás construyendo o busca por palabra clave`)
};

const fr_search_input_placeholder = /** @type {(inputs: Search_Input_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Décrivez ce que vous construisez, ou cherchez par mot-clé`)
};

const de_search_input_placeholder = /** @type {(inputs: Search_Input_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beschreibe, was du baust, oder suche per Keyword`)
};

const ru_search_input_placeholder = /** @type {(inputs: Search_Input_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Опишите, что вы строите, или ищите по ключевому слову`)
};

const it_search_input_placeholder = /** @type {(inputs: Search_Input_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descrivi cosa stai costruendo, o cerca per parola chiave`)
};

/**
* | output |
* | --- |
* | "Describe what you're building, or search by keyword" |
*
* @param {Search_Input_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const search_input_placeholder = /** @type {((inputs?: Search_Input_PlaceholderInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Input_PlaceholderInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_search_input_placeholder(inputs)
	if (locale === "pt-BR") return pt_br2_search_input_placeholder(inputs)
	if (locale === "es") return es_search_input_placeholder(inputs)
	if (locale === "fr") return fr_search_input_placeholder(inputs)
	if (locale === "de") return de_search_input_placeholder(inputs)
	if (locale === "ru") return ru_search_input_placeholder(inputs)
	if (locale === "it") return it_search_input_placeholder(inputs)
	return en_search_input_placeholder(inputs)
});